module.exports = __webpack_public_path__ + "img/unifgua-branco.3e1c6b52.svg";